import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36afaac8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "报修信息", -1));
const _hoisted_3 = {
  class: "activity"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "门店", -1));
const _hoisted_5 = {
  class: "cl7c7c7c"
};
const _hoisted_6 = {
  class: "activity vendor"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点位", -1));
const _hoisted_8 = {
  class: "cl7c7c7c"
};
const _hoisted_9 = {
  class: "imgBox"
};
const _hoisted_10 = {
  class: "activity location vendor"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态", -1));
const _hoisted_12 = {
  class: "imgUp"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "维修照片", -1));
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "btnBox"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, _toDisplayString($setup.uploadTableData.storeInfo.storeName), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString($setup.uploadTableData.storeInfo.storeFloor + "-" + $setup.uploadTableData.storeInfo.locationDescription), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString($setup.uploadTableData.storeInfo.repairResultNameZh), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", null, [_createVNode(_component_el_upload, {
    "file-list": $setup.uploadTableData.uploadedList,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => $setup.uploadTableData.uploadedList = $event),
    "list-type": "picture-card",
    limit: $setup.maxNum,
    ref: "uploadTable",
    action: $setup.uploadTableData.signatureData.host,
    "before-upload": file => {
      return $setup.handleBefore(file);
    },
    "on-success": (response, file, fileList) => {
      return $setup.handleStoreOnSuccess(response, file, fileList);
    },
    data: $setup.uploadTableData.data,
    "on-exceed": $setup.handleExceed,
    "before-remove": (file, fileList) => {
      return $setup.onBeforeRemove(file, fileList);
    },
    "on-remove": $setup.onRemove,
    "on-preview": $setup.handlePictureCardPreview,
    disabled: $setup.getDisabled($setup.uploadTableData.storeInfo.repairResultId),
    class: _normalizeClass({
      reached_the_limit: $setup.getDisabled($setup.uploadTableData.storeInfo.repairResultId)
    }),
    accept: "image/*"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Plus)]),
      _: 1
    })]),
    _: 1
  }, 8, ["file-list", "limit", "action", "before-upload", "on-success", "data", "on-exceed", "before-remove", "on-remove", "on-preview", "disabled", "class"])])])]), _createVNode(_component_el_dialog, {
    modelValue: $setup.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.dialogVisible = $event),
    class: "preViewBox",
    style: {
      "width": "90vw",
      "height": "auto",
      "margin-top": "20vh"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      "w-full": "",
      src: $setup.dialogImageUrl,
      alt: "Preview Image",
      style: {
        "width": "100%"
      }
    }, null, 8, _hoisted_14)]),
    _: 1
  }, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", _hoisted_15, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
    class: "defaultBtn",
    color: "#000",
    onClick: $setup.submitRepairInfo
  }, {
    default: _withCtx(() => [_createTextVNode("下一步")]),
    _: 1
  }, 8, ["onClick"])), [[_directive_loading, $setup.fullscreenLoading, void 0, {
    fullscreen: true,
    lock: true
  }]]), _createVNode(_component_el_button, {
    class: "defaultBtn",
    onClick: _cache[2] || (_cache[2] = $event => $setup.router.go(-1))
  }, {
    default: _withCtx(() => [_createTextVNode("取消")]),
    _: 1
  })], 512), [[_vShow, !$setup.getDisabled($setup.uploadTableData.storeInfo.repairResultId)]])]);
}